<template>
  <div id="app">
    <a-config-provider :locale="locale"
      :theme="{
          token: {
            colorPrimary: '#209B3D',
          },
      }"
    >
      <router-view></router-view>
    </a-config-provider>
  </div>
</template>

<script>
  import zhCN from 'ant-design-vue/es/locale/zh_CN';
  export default {
    name: 'App',
    data() {
      return {
        locale: zhCN,
      };
    },
  }
</script>

<style scoped>

</style>
